// Braindate single-sign-on: the platform accepts an ext-id/ext-token pair as
// query params. Same credentials the /braindate root redirect has always used
// (see app/components/fragments/braindate/index.vue).
export const appendBraindateSso = (url, user) => {
    if (!url || !user?.braindateHash || !user?.email) return url;
    const sep = url.includes('?') ? '&' : '?';
    const id = encodeURIComponent(user.braindateHash);
    const token = encodeURIComponent(user.email);
    return `${url}${sep}ext-id=${id}&ext-token=${token}`;
};

// A redirect target reaches us as a query param after the login round trip, so
// treat it as attacker-controlled. The target must be an absolute URL on the
// Braindate origin — no base is passed to URL() here, deliberately, so a
// relative or scheme-less string throws instead of silently resolving against
// our own origin. Anything off the configured Braindate origin is dropped —
// otherwise our own domain becomes an open redirect, and the SSO pair we
// append would hand the visitor's email to the destination.
export const safeBraindateTarget = (to, braindateUrl) => {
    if (!to) return braindateUrl;
    try {
        const base = new URL(braindateUrl);
        const target = new URL(to);
        return target.origin === base.origin ? target.toString() : braindateUrl;
    } catch {
        return braindateUrl;
    }
};
